import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://tgzzoovxtqepcrllvsyu.supabase.co';
const SUPABASE_KEY = 'sb_publishable_m5H1DYitg-WT9pi_BUFiOw_ZLAhQiKl';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
